export default __webpack_public_path__ + "static/media/logo.caeb988d.svg";